export const certificateTitle = (
    <>
        <span>Honors</span> received
    </>
);
export const certificateTitleUA = (
    <>
        <span>Отримані</span> нагороди
    </>
);

export const copied = 'copied';
export const copiedUA = 'скопійовано';

export const verify = 'click to verify';
export const verifyMobile = 'tap to verify';
export const verifyUA = 'клік для перевірки';
export const verifyUAMobile = 'тап для перевірки';

export const verification = 'Verification';
export const verificationUA = 'Перевірка';

export const certificationData = [
    {
        sort: 5,
        title: 'Practical NODE.js',
        img: 'img/certificates/Nodejs_certificate.webp',
        url: 'https://drive.google.com/file/d/1qj51MhHaZVUzCUqTBQBJdbQffYsxTfj-/view?usp=drive_link',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Level',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Grade',
                tag: 'Grade',
                value: '335.95 / 340',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Issued date',
                tag: 'Issued date',
                value: 'Nov 24, 2023',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Series',
                tag: 'Series',
                value: 'ID',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Number',
                tag: 'Number',
                value: '15695/2023',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Certificated by',
                tag: 'Certificated by',
                value: 'SoftServe IT Academy',
                copied: false,
            },
        ],
    },
    {
        sort: 2,
        title: 'Web UI Certification',
        img: 'img/certificates/WebUICertificate.webp',
        url: 'https://drive.google.com/file/d/16O0ccStTElqttlmEEnixT0-JtuGftlPr/view?usp=share_link',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Level',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Grade',
                tag: 'Grade',
                value: '77%',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Issued date',
                tag: 'Issued date',
                value: 'Feb 15, 2023',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Series',
                tag: 'Series',
                value: 'ZJ',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Number',
                tag: 'Number',
                value: '11437/2023',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Certificated by',
                tag: 'Certificated by',
                value: 'SoftServe University',
                copied: false,
            },
        ],
    },
    {
        sort: 4,
        title: 'React Online Marathon',
        img: 'img/certificates/React_marathon_certificate.webp',
        url: 'https://drive.google.com/file/d/1pvRlKD6ObRQNNXS1kmCIvwIc5biPhroj/view?usp=share_link',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Level',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Grade',
                tag: 'Grade',
                value: '345.07 / 347',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Issued date',
                tag: 'Issued date',
                value: 'Dec 23, 2022',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Series',
                tag: 'Series',
                value: 'BQ',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Number',
                tag: 'Number',
                value: '11437/2023',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Certificated by',
                tag: 'Certificated by',
                value: 'SoftServe IT Academy',
                copied: false,
            },
        ],
    },
    {
        sort: 3,
        title: 'English evaluation',
        img: 'img/certificates/english-level.webp',
        url: 'https://drive.google.com/file/d/1NN6zmUwL5KENkiPzygwYBM9B2uRp-L44/view?usp=sharing',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Level',
                tag: 'Level',
                value: 'INTERMEDIATE STRONG',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Grade',
                tag: 'Grade',
                value: '',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Issued date',
                tag: 'Issued date',
                value: 'Aug 17, 2022',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Series',
                tag: 'Series',
                value: 'CC',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Number',
                tag: 'Number',
                value: '9545/2022',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Evaluated by',
                tag: 'Evaluated by',
                value: 'SoftServe University',
                copied: false,
            },
        ],
    },
    {
        sort: 1,
        title: 'Web development',
        img: 'img/certificates/nikos-certificate.webp',
        url: 'https://drive.google.com/file/d/1itoPOKnWBQp9aDlfn8t8PJLZDhktYBCM/view?usp=share_link',
        verificationUrl: '',
        info: [
            {
                id: 1,
                infoTitle: 'Level',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Grade',
                tag: 'Grade',
                value: '',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Issued date',
                tag: 'Issued date',
                value: 'Dec 03, 2021',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Series',
                tag: 'Series',
                value: '',
                copied: false,
            },
            {
                id: 6,
                infoTitle: 'Number',
                tag: 'Number',
                value: '',
                copied: false,
            },
            {
                id: 3,
                infoTitle: 'Certificated by',
                tag: 'Certificated by',
                value: 'NIKOS-LTV',
                copied: false,
            },
        ],
    },
];

export const certificationDataUA = [
    {
        sort: 5,
        title: 'Практичний Node.js',
        img: 'img/certificates/Nodejs_certificate.webp',
        url: 'https://drive.google.com/file/d/1qj51MhHaZVUzCUqTBQBJdbQffYsxTfj-/view?usp=drive_link',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Рівень',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Оцінка',
                tag: 'Grade',
                value: '335.95 / 340',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Дата видачі',
                tag: 'Issued date',
                value: '24 листопада 2023 р.',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Серія',
                tag: 'Series',
                value: 'ID',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Номер',
                tag: 'Number',
                value: '15695/2023',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Виданий',
                tag: 'Certificated by',
                value: 'SoftServe IT Academy',
                copied: false,
            },
        ],
    },
    {
        sort: 2,
        title: 'Сертифікація з Веб розробки',
        img: 'img/certificates/WebUICertificate.webp',
        url: 'https://drive.google.com/file/d/16O0ccStTElqttlmEEnixT0-JtuGftlPr/view?usp=share_link',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Рівень',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Оцінка',
                tag: 'Grade',
                value: '77%',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Дата видачі',
                tag: 'Issued date',
                value: '15 лютого 2023 р.',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Серія',
                tag: 'Series',
                value: 'ZJ',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Номер',
                tag: 'Number',
                value: '11437/2023',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Виданий',
                tag: 'Certificated by',
                value: 'SoftServe University',
                copied: false,
            },
        ],
    },
    {
        sort: 4,
        title: 'React онлайн марафон',
        img: 'img/certificates/React_marathon_certificate.webp',
        url: 'https://drive.google.com/file/d/1pvRlKD6ObRQNNXS1kmCIvwIc5biPhroj/view?usp=share_link',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Рівень',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Оцінка',
                tag: 'Grade',
                value: '368.07 / 370',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Дата видачі',
                tag: 'Issued date',
                value: '23 грудня 2022 р.',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Серія',
                tag: 'Series',
                value: 'BQ',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Номер',
                tag: 'Number',
                value: '11437/2023',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Виданий',
                tag: 'Certificated by',
                value: 'SoftServe IT Academy',
                copied: false,
            },
        ],
    },
    {
        sort: 3,
        title: 'Оцінка рівня англійської мови',
        img: 'img/certificates/english-level.webp',
        url: 'https://drive.google.com/file/d/1NN6zmUwL5KENkiPzygwYBM9B2uRp-L44/view?usp=sharing',
        verificationUrl:
            'https://career.softserveinc.com/uk-ua/certification/verification',
        info: [
            {
                id: 1,
                infoTitle: 'Рівень',
                tag: 'Level',
                value: 'ВПЕВНЕНИЙ СЕРЕДНІЙ',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Оцінка',
                tag: 'Grade',
                value: '',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Дата видачі',
                tag: 'Issued date',
                value: '17 серпня 2022 р.',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Серія',
                tag: 'Series',
                value: 'CC',
                copied: true,
            },
            {
                id: 6,
                infoTitle: 'Номер',
                tag: 'Number',
                value: '9545/2022',
                copied: true,
            },
            {
                id: 3,
                infoTitle: 'Оцінено',
                tag: 'Evaluated by',
                value: 'SoftServe University',
                copied: false,
            },
        ],
    },
    {
        sort: 1,
        title: 'Веб розробка',
        img: 'img/certificates/nikos-certificate.webp',
        url: 'https://drive.google.com/file/d/1itoPOKnWBQp9aDlfn8t8PJLZDhktYBCM/view?usp=share_link',
        verificationUrl: '',
        info: [
            {
                id: 1,
                infoTitle: 'Рівень',
                tag: 'Level',
                value: '',
                copied: false,
            },
            {
                id: 2,
                infoTitle: 'Оцінка',
                tag: 'Grade',
                value: '',
                copied: false,
            },
            {
                id: 4,
                infoTitle: 'Дата видачі',
                tag: 'Issued date',
                value: '03 грудня 2021р.',
                copied: false,
            },
            {
                id: 5,
                infoTitle: 'Серія',
                tag: 'Series',
                value: '',
                copied: false,
            },
            {
                id: 6,
                infoTitle: 'Номер',
                tag: 'Number',
                value: '',
                copied: false,
            },
            {
                id: 3,
                infoTitle: 'Виданий',
                tag: 'Certificated by',
                value: 'Нікос-ЛТД',
                copied: false,
            },
        ],
    },
];
